





define(['./geocode'], function(geocodeModel) {
    'use strict';

    return function(data) {
        if (!(data.batchItems instanceof Array)) {
            return null;
        }
        return data.batchItems.map(function(batchItem) {
            if (batchItem.response.error) {
                return { error: batchItem.response.error};
            } else {
                return geocodeModel(batchItem.response);
            }
        });
    };
});



// WEBPACK FOOTER //
// ./model/geocode/batchGeocode.js